// removed by extract-text-webpack-plugin
module.exports = {"starWrap":"qempo_Rating_starWrap-leJ2qaR","filled":"qempo_Rating_filled-SbvESV-"};


//////////////////
// WEBPACK FOOTER
// ./src/elements/Rating/Rating.scss
// module id = 1704
// module chunks = 0